import React from 'react';
import logoPath from "@assets/Asset 1_1750308719655.png";

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <img
      src={logoPath}
      alt="SaaSGama"
      className={className}
    />
  );
}